import { render } from "./IconSpeaker.vue?vue&type=template&id=3151d0a0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSpeaker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3151d0a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3151d0a0', __exports__)) {
    api.reload('3151d0a0', __exports__)
  }
  
  module.hot.accept("./IconSpeaker.vue?vue&type=template&id=3151d0a0", () => {
    api.rerender('3151d0a0', render)
  })

}


export default __exports__